/**
 * Motivos abstractos del aula — rúbrica, vincula, orden, ritmo —
 * decoración atmosférica (sin labels, aria-hidden).
 */
export function LandingMotifs() {
  return (
    <div className="sala-landing-motifs" aria-hidden="true">
      {/* Rúbrica: matriz de niveles */}
      <svg className="sala-landing-motif sala-landing-motif--rubric" viewBox="0 0 120 96" fill="none">
        <rect x="4" y="4" width="112" height="88" rx="10" className="sala-landing-motif__frame" />
        {[0, 1, 2, 3].map((row) =>
          [0, 1, 2, 3].map((col) => (
            <rect
              key={`${row}-${col}`}
              x={14 + col * 24}
              y={14 + row * 18}
              width="16"
              height="10"
              rx="2"
              className="sala-landing-motif__cell"
              style={{ animationDelay: `${(row * 4 + col) * 0.12}s` }}
            />
          )),
        )}
      </svg>

      {/* Vincula: términos pares */}
      <svg className="sala-landing-motif sala-landing-motif--vincula" viewBox="0 0 140 88" fill="none">
        {[0, 1, 2].map((i) => (
          <g key={i} className="sala-landing-motif__pair" style={{ animationDelay: `${i * 0.35}s` }}>
            <rect x="8" y={10 + i * 26} width="42" height="16" rx="8" className="sala-landing-motif__chip" />
            <path
              d={`M54 ${18 + i * 26} C72 ${18 + i * 26 - (i - 1) * 10}, 84 ${18 + i * 26 + (i - 1) * 10}, 96 ${18 + i * 26}`}
              className="sala-landing-motif__link"
            />
            <rect x="96" y={10 + i * 26} width="36" height="16" rx="8" className="sala-landing-motif__chip sala-landing-motif__chip--alt" />
          </g>
        ))}
      </svg>

      {/* Orden: secuencia de pasos */}
      <svg className="sala-landing-motif sala-landing-motif--order" viewBox="0 0 48 160" fill="none">
        {[0, 1, 2, 3].map((i) => (
          <g key={i} className="sala-landing-motif__step" style={{ animationDelay: `${i * 0.28}s` }}>
            <circle cx="24" cy={18 + i * 38} r="11" className="sala-landing-motif__node" />
            {i < 3 ? (
              <path d={`M24 ${29 + i * 38} V${45 + i * 38}`} className="sala-landing-motif__spine" />
            ) : null}
          </g>
        ))}
      </svg>

      {/* Ritmo: pulsos / figuras */}
      <svg className="sala-landing-motif sala-landing-motif--rhythm" viewBox="0 0 160 64" fill="none">
        {[0, 1, 2, 3, 4].map((i) => {
          const h = [18, 34, 26, 42, 22][i];
          return (
            <rect
              key={i}
              x={16 + i * 28}
              y={56 - h}
              width="12"
              height={h}
              rx="4"
              className="sala-landing-motif__beat"
              style={{ animationDelay: `${i * 0.16}s` }}
            />
          );
        })}
      </svg>

      {/* Glosario / fichas sueltas */}
      <svg className="sala-landing-motif sala-landing-motif--cards" viewBox="0 0 100 72" fill="none">
        <rect x="8" y="18" width="52" height="40" rx="8" className="sala-landing-motif__card" />
        <rect x="36" y="8" width="52" height="40" rx="8" className="sala-landing-motif__card sala-landing-motif__card--front" />
        <path d="M46 22 H76 M46 32 H68" className="sala-landing-motif__lines" />
      </svg>
    </div>
  );
}
